export enum ChannelsEnum {
    PUSH = 'push',
    SMS = 'sms',
    EMAIL = 'email',
    WHATSAPP = 'whatsapp',
}